import React, { useState } from 'react';

interface JoinRoomModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRoomJoined: (roomId: string) => void;
}

const JoinRoomModal: React.FC<JoinRoomModalProps> = ({
  isOpen,
  onClose,
  onRoomJoined,
}) => {
  const [roomId, setRoomId] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleJoinRoom = async () => {
    if (!roomId.trim()) {
      setError('Please enter a room ID');
      return;
    }

    // Navigate to lobby with autoJoin flag instead of joining directly
    // This allows WebSocket connection to be established first
    onRoomJoined(roomId.trim());
    onClose();
    setRoomId('');
  };

  const handleClose = () => {
    setRoomId('');
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Join Room</h2>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="roomId" className="form-label">
              Room ID
            </label>
            <input
              id="roomId"
              type="text"
              value={roomId}
              onChange={(e) => setRoomId(e.target.value)}
              placeholder="Enter the room ID to join"
              className="form-input"
            />
          </div>
          {error && (
            <div className="alert alert-error">
              {error}
              <button className="alert-close" onClick={() => setError(null)}>×</button>
            </div>
          )}
        </div>
        
        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button 
            className="btn btn-primary"
            onClick={handleJoinRoom} 
            disabled={!roomId.trim()}
          >
            🚪 Join Room
          </button>
        </div>
      </div>
    </div>
  );
};

export default JoinRoomModal;